import App from '../App'//PC端
import mApp from '../mApp'//移动端
//PC端
const home = r => require.ensure([], () => r(require('../page/home/home')), 'home');
const goodDetail = r => require.ensure([], () => r(require('../page/good/detail')), 'goodDetail');
const cart = r => require.ensure([], () => r(require('../page/cart/cart')), 'cart');
const login = r => require.ensure([], () => r(require('../page/login/login')), 'login');
const register = r => require.ensure([], () => r(require('../page/login/register')), 'register');
const forgetkey = r => require.ensure([], () => r(require('../page/login/forgetkey')), 'forgetkey');
const userInfo = r => require.ensure([], () => r(require('../page/login/userInfo')), 'userInfo');
const orderConfirm = r => require.ensure([], () => r(require('../page/order/confirm')), 'orderConfirm');
const orderPay = r => require.ensure([], () => r(require('../page/order/pay')), 'orderPay');
const ucIndex = r => require.ensure([], () => r(require('../page/userCenter/index/index')), 'ucIndex');
const order = r => require.ensure([], () => r(require('../page/userCenter/order/order')), 'order');
const orderDetail = r => require.ensure([], () => r(require('../page/userCenter/order/detail')), 'orderDetail');

const address = r => require.ensure([], () => r(require('../page/userCenter/address/address')), 'address');
const collect = r => require.ensure([], () => r(require('../page/userCenter/collect/collect')), 'collect');
const invoice = r => require.ensure([], () => r(require('../page/userCenter/invoice/invoice')), 'invoice');
const myEvaluate = r => require.ensure([], () => r(require('../page/userCenter/evaluate/mine')), 'myEvaluate');
const evaluate = r => require.ensure([], () => r(require('../page/userCenter/evaluate/evaluate')), 'evaluate');
const message = r => require.ensure([], () => r(require('../page/userCenter/message/message')), 'message');

//移动端
const mHome = r => require.ensure([], () => r(require('../mpage/home/home')), 'mHome');
const mSort = r => require.ensure([], () => r(require('../mpage/sort/sort')), 'mSort');
const mSortGood = r => require.ensure([], () => r(require('../mpage/sort/good')), 'mSortGood');

const mGoodDetail = r => require.ensure([], () => r(require('../mpage/good/detail')), 'mGoodDetail');
const mGoodEvaluate = r => require.ensure([], () => r(require('../mpage/good/evaluate')), 'mGoodEvaluate');
const mCart = r => require.ensure([], () => r(require('../mpage/cart/cart')), 'mCart');
const mCartEdit = r => require.ensure([], () => r(require('../mpage/cart/edit')), 'mCartEdit');//编辑购物车
const mLogin = r => require.ensure([], () => r(require('../mpage/login/login')), 'mLogin');
const mRegister = r => require.ensure([], () => r(require('../mpage/login/register')), 'mRegister');

const mForgetkey = r => require.ensure([], () => r(require('../mpage/login/forgetkey')), 'mForgetkey');
const mUserInfo = r => require.ensure([], () => r(require('../mpage/login/userInfo')), 'mUserInfo');

const mOrderConfirm = r => require.ensure([], () => r(require('../mpage/order/confirm')), 'mOrderConfirm');
const mPay = r => require.ensure([], () => r(require('../mpage/order/pay')), 'mPay');
const mOrderAddress = r => require.ensure([], () => r(require('../mpage/order/address')), 'mOrderAddress');
const mOrderAdd = r => require.ensure([], () => r(require('../mpage/order/add')), 'mOrderAdd');
const mOrderInvoice = r => require.ensure([], () => r(require('../mpage/order/invoice')), 'mOrderInvoice');
const mUcIndex = r => require.ensure([], () => r(require('../mpage/userCenter/index/index')), 'mUcIndex');

const mOrder = r => require.ensure([], () => r(require('../mpage/userCenter/order/order')), 'mOrder');
const mOrderDetail = r => require.ensure([], () => r(require('../mpage/userCenter/order/detail')), 'mOrderDetail');
const mLogistics = r => require.ensure([], () => r(require('../mpage/userCenter/order/logistics')), 'mLogistics');
const mAddress = r => require.ensure([], () => r(require('../mpage/userCenter/address/address')), 'mAddress');
const mAdd = r => require.ensure([], () => r(require('../mpage/userCenter/address/add')), 'mAdd');//添加或编辑地址
const mCollect = r => require.ensure([], () => r(require('../mpage/userCenter/collect/collect')), 'mCollect');
const mInvoice = r => require.ensure([], () => r(require('../mpage/userCenter/invoice/invoice')), 'mInvoice');
const mInvoiceAdd = r => require.ensure([], () => r(require('../mpage/userCenter/invoice/add')), 'mInvoiceAdd');
const mMyEvaluate = r => require.ensure([], () => r(require('../mpage/userCenter/evaluate/mine')), 'mMyEvaluate');
const mEvaluate = r => require.ensure([], () => r(require('../mpage/userCenter/evaluate/evaluate')), 'mEvaluate');
const mMessage = r => require.ensure([], () => r(require('../mpage/userCenter/message/message')), 'mMessage');


var pc = [{
  path: '/',
  component: App, //顶层路由，对应index.html
  children: [
      //二级路由。对应App.vue
      //地址为空时跳转home页面
    {
      path: '',
      redirect: '/home'///home
    },
    {
      path: '/home',
      name:'home',
      component: home
    },
    {
      path: '/good/detail', //产品详情页
      name:'goodDetail',
      component: goodDetail,
    },
    {
      path: '/cart/cart', //购物车
      name:'cart',
      component: cart,
    },
    {
      path: '/login/login', //登录
      name:'login',
      component: login,
    },
    {
      path: '/login/register', //注册
      name:'register',
      component: register,
    },
    {
      path: '/login/userInfo', //绑定用户信息
      name:'userInfo',
      component: userInfo,
    },
    {
      path: '/login/forgetkey', //忘记密码
      name:'forgetkey',
      component: forgetkey,
    },
    {
      path: '/order/confirm', //订单确认
      name:'orderConfirm',
      component: orderConfirm,
    },
    {
      path: '/userCenter/index/index', //用户中心
      name: 'ucIndex',
      component: ucIndex,
    },
    {
      path: '/userCenter/order/order', //我的订单
      name:'order',
      component: order,
    },
    {
      path: '/userCenter/order/detail', //订单详情
      name:'orderDetail',
      component: orderDetail,
    },
    {
      path: '/order/pay', //订单支付
      name:'orderPay',
      component: orderPay,
    },
    {
      path: '/userCenter/address/address', //我的地址
      name:'address',
      component: address,
    },
    {
      path: '/userCenter/collect/collect', //我的收藏
      name:'collect',
      component: collect,
    },
    {
      path: '/userCenter/invoice/invoice', //我的发票
      name:'invoice',
      component: invoice,
    },
    {
      path: '/userCenter/evaluate/mine', //我的评价
      name:'myEvaluate',
      component: myEvaluate,
    },
    {
      path: '/userCenter/evaluate/evaluate', //发表评价
      name:'evaluate',
      component: evaluate,
    },
    {
      path: '/userCenter/message/message', //我的消息
      name:'message',
      component: message,
    }
  ]
}];

var wap = [{
  path: '/',
  component: mApp, //顶层路由，对应index.html
  children: [
    //二级路由。对应App.vue
    //地址为空时跳转home页面
    {
      path: '',
      redirect: '/home'///home
    },
    {
      path: '/home',
      name:'mHome',
      component: mHome
    },
    {
      path: '/sort/sort',//分类页
      name:'mSort',
      component: mSort
    },
    {
      path: '/sort/good',//分类筛选产品
      name:'mSortGood',
      component: mSortGood
    },
    {
      path: '/good/detail', //产品详情页
      name:'mGoodDetail',
      component: mGoodDetail,
    },
    {
      path: '/good/evaluate', //产品评价
      name:'mGoodEvaluate',
      component: mGoodEvaluate,
    },
    {
      path: '/cart/cart', //购物车
      name:'mCart',
      component: mCart,
    },
    {
      path: '/cart/edit', //购物车
      name:'mCartEdit',
      component: mCartEdit,
    },
    {
      path: '/order/confirm', //订单确认
      name:'mOrderConfirm',
      component: mOrderConfirm,
    },
    {
      path: '/order/address', //订单地址选择
      name:'mOrderAddress',
      component: mOrderAddress,
    },
    {
      path: '/order/add', //添加地址
      name:'mOrderAdd',
      component: mOrderAdd,
    },
    {
      path: '/order/invoice', //发票选择
      name:'mOrderInvoice',
      component: mOrderInvoice,
    },
    {
      path: '/order/pay', //付款
      name:'mPay',
      component: mPay,
    },
    {
      path: '/login/login', //登录
      name:'mLogin',
      component: mLogin,
    },
    {
      path: '/login/register', //注册
      name:'mRegister',
      component: mRegister,
    },
    {
      path: '/login/userInfo', //绑定用户信息
      name:'mUserInfo',
      component: mUserInfo,
    },
    {
      path: '/login/forgetkey', //忘记密码
      name:'mForgetkey',
      component: mForgetkey,
    },
    {
      path: '/userCenter/index/index', //用户中心
      name: 'mUcIndex',
      component: mUcIndex,
    },
    {
      path: '/userCenter/order/order', //我的订单
      name:'mOrder',
      component: mOrder,
    },
    {
      path: '/userCenter/order/detail', //订单详情
      name:'mOrderDetail',
      component: mOrderDetail,
    },
    {
      path: '/userCenter/order/logistics', //物流详情
      name:'mLogistics',
      component: mLogistics,
    },
    {
      path: '/userCenter/address/address', //我的地址
      name: mAddress,
      component: mAddress,
    },
    {
      path: '/userCenter/address/add', //新建&编辑地址
      name: mAdd,
      component: mAdd,
    },
    {
      path: '/userCenter/collect/collect', //我的收藏
      name:'mCollect',
      component: mCollect,
    },
    {
      path: '/userCenter/invoice/invoice', //我的发票
      name:'mInvoice',
      component: mInvoice,
    },
    {
      path: '/userCenter/invoice/add', //新建&编辑发票
      name:'mInvoiceAdd',
      component: mInvoiceAdd,
    },
    {
      path: '/userCenter/evaluate/mine', //我的评价
      name:'mMyEvaluate',
      component: mMyEvaluate,
    },
    {
      path: '/userCenter/evaluate/evaluate', //发表评价
      name:'mEvaluate',
      component: mEvaluate,
    },
    {
      path: '/userCenter/message/message', //我的消息
      name:'mMessage',
      component: mMessage,
    }
  ]
}];

function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod","Blackberry"];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}
var use;
if(IsPC()){
  use = pc;
}else{
  use = wap;
}

export default use;



// WEBPACK FOOTER //
// ./src/router/index.js